import {
  switchId,
  type CompanyAccess,
  type EffectiveAccess,
  type SwitchRef,
} from "@/api/access/access.types";

const grants = (company: CompanyAccess, s: SwitchRef): boolean =>
  company.bypass !== null || Object.hasOwn(company.switches, switchId(s));

/** Contract 4.2, copied from the backend so a screen hides what the server would refuse. */
export function hasSwitch(access: EffectiveAccess, tenantId: string, s: SwitchRef): boolean {
  if (access.superUser) return true;
  if (!Object.hasOwn(access.companies, tenantId)) return false;
  return grants(access.companies[tenantId], s);
}

export function grantingCompanies(access: EffectiveAccess, s: SwitchRef): string[] {
  return Object.entries(access.companies)
    .filter(([, company]) => grants(company, s))
    .map(([tenantId]) => tenantId);
}

export function hasSwitchAnywhere(access: EffectiveAccess, s: SwitchRef): boolean {
  return access.superUser || grantingCompanies(access, s).length > 0;
}

/**
 * The company a check answers for when the screen names none: the entity the request acts in,
 * else the one company a company login is in, else none (a merged view, which asks every
 * company).
 */
export function scopeTenantId(actingTenant: string | null, access: EffectiveAccess): string | null {
  if (actingTenant) return actingTenant;
  return access.login.kind === "company" ? access.login.tenantId : null;
}

export function holdsInScope(
  access: EffectiveAccess,
  actingTenant: string | null,
  s: SwitchRef,
): boolean {
  const company = scopeTenantId(actingTenant, access);
  return company ? hasSwitch(access, company, s) : hasSwitchAnywhere(access, s);
}
